// Invented blog posts for Attouna Services (FR/EN)
export const BLOG_POSTS = [
  {
    slug: "5-conseils-recrutement-entrepot-hiver",
    date: "2026-01-14",
    category: { fr: "Entrepôt", en: "Warehouse" },
    readMin: 5,
    cover:
      "https://images.unsplash.com/photo-1687203920859-c87cb0955630?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    title: {
      fr: "5 conseils pour recruter du personnel d'entrepôt en période hivernale",
      en: "5 tips to recruit warehouse staff during winter",
    },
    excerpt: {
      fr: "Le recrutement hivernal impose ses contraintes : absentéisme, rotation plus élevée, délais serrés. Voici nos stratégies éprouvées.",
      en: "Winter hiring has its constraints: absenteeism, higher turnover, tight timelines. Our proven strategies.",
    },
    body: {
      fr: [
        "L'hiver est une période critique pour les entrepôts : pics de commandes avant les fêtes, conditions de travail plus exigeantes, et main-d'œuvre plus volatile. Chez Attouna Services, nous observons chaque année les mêmes pièges que les gestionnaires voudraient éviter.",
        "**1. Publiez vos besoins au moins 3 semaines à l'avance.** Les meilleurs candidats ne sont pas disponibles du jour au lendemain.",
        "**2. Offrez un avantage hiver concret.** Prime de fidélisation saisonnière, transport remboursé, casse-croûte chaud : autant de leviers simples qui réduisent le taux de désistement.",
        "**3. Testez la fiabilité.** Un essai d'une journée dit souvent plus qu'un long entretien. Les profils qui tiennent la cadence sur le terrain sont vos meilleurs placements.",
        "**4. Anticipez les arrêts maladie.** Constituez une \"banque\" de candidats pré-qualifiés que vous pouvez activer en 48 h.",
        "**5. Soignez l'onboarding dès jour 1.** Un accueil structuré réduit le taux de départ dans les 14 premiers jours de près de 40 %.",
        "En combinant ces cinq leviers, nos clients maintiennent un taux de rétention hivernal supérieur à 85 %.",
      ],
      en: [
        "Winter is a critical period for warehouses: order peaks before the holidays, harsher working conditions, and a more volatile workforce. At Attouna Services, we see the same pitfalls every year that managers want to avoid.",
        "**1. Post your needs at least 3 weeks in advance.** Top candidates are not available overnight.",
        "**2. Offer a concrete winter perk.** Seasonal retention bonus, reimbursed transit, hot meal vouchers — simple levers that cut no-show rates.",
        "**3. Test reliability.** A one-day trial says more than a long interview. Profiles who hold the pace on the floor are your best placements.",
        "**4. Plan for sick leave.** Build a \"bank\" of pre-qualified candidates you can activate within 48 hours.",
        "**5. Nail onboarding from day 1.** A structured welcome cuts first-14-days turnover by nearly 40%.",
        "Combining these five levers, our clients maintain a winter retention rate above 85%.",
      ],
    },
  },
  {
    slug: "paysagerie-pourquoi-sous-traiter",
    date: "2026-02-02",
    category: { fr: "Paysagerie", en: "Landscaping" },
    readMin: 4,
    cover:
      "https://images.unsplash.com/photo-1627740283098-1c544d3a479d?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    title: {
      fr: "Paysagerie : 4 raisons de confier le recrutement à une agence",
      en: "Landscaping: 4 reasons to outsource recruitment",
    },
    excerpt: {
      fr: "La saison verte est courte. Chaque semaine compte. Voici pourquoi faire appel à une agence spécialisée.",
      en: "The green season is short. Every week matters. Here's why to call a specialized agency.",
    },
    body: {
      fr: [
        "Entre mai et octobre, les entreprises de paysagerie doivent générer l'essentiel de leur chiffre d'affaires. Pas de place pour les retards de recrutement.",
        "**1. Gain de temps immédiat.** Votre équipe RH ne passe plus ses journées à filtrer des CV : nous vous présentons uniquement des candidats qualifiés.",
        "**2. Connaissance fine du secteur.** Nous savons repérer les vrais opérateurs de tondeuse autoportée, les poseurs de pavés, les élagueurs certifiés.",
        "**3. Flexibilité.** Besoin de 2 personnes cette semaine et 5 la suivante ? Notre banque de candidats s'adapte à votre rythme.",
        "**4. Conformité.** En tant qu'agence détentrice du permis CNESST AP-2604802, nous garantissons la conformité légale de chaque placement.",
      ],
      en: [
        "Between May and October, landscaping companies must generate most of their revenue. No room for hiring delays.",
        "**1. Immediate time savings.** Your HR team stops sifting through CVs: we present only qualified candidates.",
        "**2. Deep sector knowledge.** We spot real zero-turn mower operators, paver installers, certified arborists.",
        "**3. Flexibility.** Need 2 people this week and 5 next? Our candidate pool scales with your pace.",
        "**4. Compliance.** As a CNESST-permit agency (AP-2604802), we guarantee legal compliance for every placement.",
      ],
    },
  },
  {
    slug: "hotellerie-montreal-tendances-2026",
    date: "2026-02-20",
    category: { fr: "Hôtellerie", en: "Hospitality" },
    readMin: 6,
    cover:
      "https://images.unsplash.com/photo-1621891336682-341097be99cd?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    title: {
      fr: "Hôtellerie à Montréal : les 3 tendances du marché du travail en 2026",
      en: "Montreal hospitality: 3 labor market trends for 2026",
    },
    excerpt: {
      fr: "Après une reprise solide, l'hôtellerie montréalaise doit composer avec une nouvelle donne RH. Décryptage.",
      en: "After a solid recovery, Montreal hospitality must deal with a new HR landscape. A breakdown.",
    },
    body: {
      fr: [
        "Le tourisme d'affaires est reparti. Les grands événements remplissent à nouveau les carnets. Mais recruter du personnel hôtelier reste un défi — et le sera encore plus en 2026.",
        "**Tendance 1 : la polyvalence prime.** Les profils capables d'enchaîner accueil, service en salle et soutien à l'étage sont très recherchés.",
        "**Tendance 2 : la maîtrise du français et de l'anglais.** À Montréal, la clientèle est internationale. Les candidats bilingues négocient mieux leurs conditions.",
        "**Tendance 3 : la fidélisation par la culture.** Les hôtels qui investissent dans l'accueil des employés, les formations et la reconnaissance réduisent leur turnover de 25 à 35 %.",
        "En 2026, gagner la bataille du recrutement hôtelier, c'est soigner autant ses candidats que ses clients.",
      ],
      en: [
        "Business tourism is back. Major events are filling up books again. But hiring hospitality staff remains a challenge — and will be even more so in 2026.",
        "**Trend 1: versatility wins.** Profiles juggling front desk, dining service, and housekeeping support are in high demand.",
        "**Trend 2: French and English.** In Montreal, guests are international. Bilingual candidates negotiate better terms.",
        "**Trend 3: retention through culture.** Hotels investing in onboarding, training, and recognition cut turnover by 25–35%.",
        "In 2026, winning the hospitality hiring battle means caring for your candidates as much as your guests.",
      ],
    },
  },
  {
    slug: "permis-cnesst-ce-que-ca-change",
    date: "2026-01-28",
    category: { fr: "Réglementation", en: "Regulation" },
    readMin: 4,
    cover:
      "https://images.unsplash.com/photo-1758518727077-ffb66ffccced?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
    title: {
      fr: "Permis CNESST : ce que ça change pour les employeurs qui font appel à une agence",
      en: "CNESST permit: what it means for employers using an agency",
    },
    excerpt: {
      fr: "Depuis 2020, toute agence de placement doit détenir un permis CNESST. Voici les garanties que cela vous apporte.",
      en: "Since 2020, every staffing agency must hold a CNESST permit. Here's what it guarantees for you.",
    },
    body: {
      fr: [
        "Recourir à une agence de placement sans permis CNESST expose l'employeur à des sanctions et, surtout, à des pratiques de recrutement opaques.",
        "**Qu'est-ce que garantit le permis ?** Que l'agence respecte le droit du travail, verse les cotisations dues, ne retient pas indûment les salaires, et traite équitablement ses candidats.",
        "**Comment vérifier ?** Le registre public des agences est disponible sur (cnesst.gouv.qc.ca/registre).",
        "**Le permis d'Attouna Services : AP-2604802.** Il est affiché en pied de page de notre site et vérifiable en tout temps.",
        "Travailler avec une agence certifiée, c'est éliminer un risque juridique et bâtir une relation de long terme.",
      ],
      en: [
        "Using a staffing agency without a CNESST permit exposes the employer to sanctions and — more importantly — to opaque hiring practices.",
        "**What does the permit guarantee?** That the agency respects labor law, pays all dues, does not unduly withhold wages, and treats candidates fairly.",
        "**How to verify?** The public registry is available at (cnesst.gouv.qc.ca/registre).",
        "**Attouna Services permit: AP-2604802.** It is displayed in our site footer and verifiable anytime.",
        "Working with a certified agency eliminates legal risk and builds a long-term relationship.",
      ],
    },
  },
];

export function findPost(slug) {
  return BLOG_POSTS.find((p) => p.slug === slug);
}
